export default "__VITE_ASSET__CRdPJbFE__"